function registerSeeMore(): void {
  let seeMoreElements = document.querySelectorAll<HTMLElement>('.see-more');

  seeMoreElements.forEach(seeMore => {
    let button = seeMore.querySelector('.see-more-button');
    button.addEventListener('click', (e) => {
      seeMore.classList.remove('see-more-collapsed');
      seeMore.classList.add('see-more-expanded');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  registerSeeMore();
});
